import React from 'react';
import PlainButton from './common/PlainButton';

class SonificationSettingsComponent extends React.Component {
    constructor(props) {
        super(props);
        let Dyn = this.props.Dyn;
        this.state = {
            isAudioTraceOn: false,
            isPlaying: false,
            speedBPM: Dyn.sound.initialBPM, // speed in beats per minute, should this be a prop since it depends on Dyn.sound.getPlotSonifier().getBeatsPerMinute()?
            volumePercent: Dyn.sound.initialVolumePercent, // volume in decibels, should this be a prop since it depends on Dyn.sound.getMasterVolumePercent()?
        }
    }

    componentDidMount = () => {
        // Focus the panel
        let Dyn = this.props.Dyn;
        this.subscriptions = [];
        Dyn.mediatorLocalSubscribe( this.subscriptions, "sound:StopStartPause", () =>{
            // update buttons when Dyn.sound notifies us of change
            this.updateDynSoundState();
        });
        Dyn.mediatorLocalSubscribe( this.subscriptions, "sound:VolumeSpeedUpdate", () =>{
            // update buttons when Dyn.sound notifies us of change
            this.updateDynSoundState();
        });

        this.updateDynSoundState(); // set the initial state after component mounted
    };

    // respond to notifications that plot sonification has started, paused, or stopped, etc.
    updateDynSoundState = () => {
        let Dyn = this.props.Dyn;
        if( Dyn.sound.isAudioInitialized()) {
            this.setState( {
                isAudioTraceOn: Dyn.sound.isAudioTraceOn(),
                isPlaying: Dyn.sound.getPlotSonifier().isPlaying(),
                speedBPM: Dyn.sound.getPlotSonifier().getBeatsPerMinute(),
                volumePercent: Dyn.sound.getMasterVolumePercent(),
            } );
        }
    };

    getLoc = (str, parameters) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str, parameters );
    };

    handlePlayPause = (value) => {
        // toggle between playing and pausing the plot sonification
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo( () =>
            this.props.Dyn.sound.playOrPauseSonification());
    };

    handleReset = () => {
        // stop any existing play of the sonification, and play it from the beginning
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() =>
            this.props.Dyn.sound.restartSonification());
        // button states will be updated via "sound:StopStartPause" notification
    };

    handleStop = () => {
        // stop any existing play of the sonification
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() =>
            this.props.Dyn.sound.stopSonification());
        // button states will be updated via "sound:StopStartPause" notification
    };

    handleAudioTraceOnOff = () => {
        // toggle to turn on or off audio trace when selecting/clicking on data values
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() =>
            Dyn.sound.setAudioTraceOnOff( ! Dyn.sound.isAudioTraceOn()));
        // button states will be updated via "sound:StopStartPause" notification
    };

    handleSpeedSlower = () => {
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() => {
            let plotSonifier = Dyn.sound.getPlotSonifier();
            plotSonifier.setBeatsPerMinute( Math.round( plotSonifier.getBeatsPerMinute() - Dyn.sound.deltaSpeed ) );
        });
    };

    handleSpeedFaster = () => {
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() => {
            let plotSonifier = Dyn.sound.getPlotSonifier();
            plotSonifier.setBeatsPerMinute( Math.round( plotSonifier.getBeatsPerMinute() + Dyn.sound.deltaSpeed ) );
        });
    };

    handleVolumeDown = () => {
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() =>
            Dyn.sound.setMasterVolumeDB( Dyn.sound.getMasterVolumeDB() - Dyn.sound.deltaVolume ));
    };

    handleSpeedUp = () => {
        let Dyn = this.props.Dyn;
        Dyn.sound.initAudioAndDo(() =>
            Dyn.sound.setMasterVolumeDB( Dyn.sound.getMasterVolumeDB() + Dyn.sound.deltaVolume ));
    };

    render = () => {
        return (
            <div ref="sonificationSettingsPanel" tabIndex="0" style={this.props.style}>
                <div className="tde-mx-2 tde-s1-size tde-d-flex tde-mt-3 tde-toggle-btns-wrapper">
                    <p
                        className="tde-label"
                        role="heading"
                        aria-level="3">{ this.getLoc('Sonification') }</p>
                </div>
                {/* disabled={!this.isSampleSizeValid() || !this.state.hasAttribute || this.state.invalidSampleSize}  */}
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handlePlayPause}>
                            { this.getLoc(this.state.isPlaying?'Pause':'Play') }</button>
                    <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleReset}>
                            { this.getLoc('Restart') }</button>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleStop}>
                    { this.getLoc('Stop') }</button>
                <br/>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleSpeedSlower}>
                    { this.getLoc('Slower') }</button>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleSpeedFaster}>
                    { this.getLoc('Faster') }</button>
                <span>{' '+this.getLoc('{{speedBPM}} bpm', {speedBPM:this.state.speedBPM})}</span>
                <br/>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleVolumeDown}>
                    { this.getLoc('Softer') }</button>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleSpeedUp}>
                    { this.getLoc('Louder') }</button>
                <span>{' '+this.getLoc('{{volumePercent}}%', {volumePercent:Math.round(this.state.volumePercent)})}</span>
                <br/>
                <button className="tde-btn tde-active tde-s1 tde-font-weight-semibold tde-ml-2 tde-mt-3" onClick={this.handleAudioTraceOnOff}>
                    { this.getLoc(this.state.isAudioTraceOn?'Audio Trace is ON':'Audio Trace is OFF') }</button>
                <div className="tde-mb-6"></div>
            </div>
        );
    }
}

export default SonificationSettingsComponent
